import LeftSide from "/components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";
import { wrapper } from "../../redux";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Maper from "/components/pages/contacts/maper";
import Redis from "/lib/redis";
import { Api } from "/api";
import pagesWrapper from "../../utils/pagesWrapper";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { useRouter } from "next/router";

export default function DeliveryPage({ scripts, host, isBaltex }) {
  const { cityName, deliveryCityData, deliveryCityDataLoaded } = useSelector(
    (state) => state.location,
  );
  const { contactsData } = useSelector((state) => state.contacts);
  const [pointId] = useState(null);
  const [tkPoints, setTkPoints] = useState([]);

  const text = useMemo(() => {
    return contactsData.DELIVERY_TEXT?.replaceAll("#CITY_NAME#", cityName);
  }, [contactsData, cityName]);

  const isEdost = contactsData?.ID === "86897";
  const isSdek = contactsData.ID && contactsData.ID !== "86897";
  const zoom = 10;
  const router = useRouter();
  useEffect(async () => {
    if (deliveryCityDataLoaded) {
      if (isEdost) {
        setTkPoints(
          await Api.edost.getPointsOld(
            cityName,
            `${deliveryCityData?.region} ${deliveryCityData?.region_type_full}`,
          ),
        );
      } else if (isSdek) {
        setTkPoints(
          await Api.server.getSdekPoints(cityName, Boolean(router.query.reset)),
        );
      }
    }
  }, [cityName, contactsData, deliveryCityDataLoaded]);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title="Доставка"
      >
        <div className={"text"} dangerouslySetInnerHTML={{ __html: text }} />

        {tkPoints.length > 0 && (
          <div>
            <h2>Пункты выдачи</h2>
            <Maper zoom={zoom} points={tkPoints} pointId={pointId} />
          </div>
        )}
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ req, query }) => {
    store.dispatch(addBreadcrumb({ link: "/delivery/", name: "Доставка" }));

    return pagesWrapper(
      {},
      store,
      Redis,
      {
        query,
        req,
      },
      "/delivery/",
    );
  };
});
